// extracted by mini-css-extract-plugin
module.exports = {"container":"Color_container__3_-E1","overlay":"Color_overlay__24VcD"};